const resources = {
    chatSectionTitle: 'Questions about this product? Let’s chat!',
    chatSectionSubtitle: 'Get expert answers and advice from our Beauty Advisors.'
};

module.exports = function getResource(label) {
    return resources[label];
};
